import { formatDate } from '@utils/timeFormatter';
import { useTranslation } from 'react-i18next';
import { Project } from '../../../../../../../types/psychometric';

interface ProjectItemProps {
  project: Project;
}

export default function ProjectItem({ project }: ProjectItemProps) {
  const { t } = useTranslation();
  return (
    <div className="pb-8 border-b border-white-200 last:border-0">
      <h3 className="text-lg font-semibold text-white-900">{project.name}</h3>
      <p className="text-sm text-white-500 mb-2">
        {formatDate((project.startDate as unknown as number) * 1000)} -{' '}
        {project.endDate
          ? formatDate((project.endDate as unknown as number) * 1000)
          : t('profile.present')}
      </p>
      {project.description && (
        <p className="text-white-700">{project.description}</p>
      )}
    </div>
  );
}
